import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import SimpleInput from 'components/forms/SimpleInput'
import HelpParameter from '../HelpParameter'

const ParameterWithSimpleInput = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = [],
    getGlobalModuleParameter = () => {},
    isGlobal = false,

    parameter,
    title = '',
    helpImage,
    type,

    placeholder = '',
    iconTooltip,
}) => {
    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [stateParameter, setStateParameter] = useState(foundParameter)
    const [stateModuleParameter, setStateModuleParameter] = useState(foundModuleParameter)

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, stateParameter),
        ])
    }, 200, [stateParameter])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, stateModuleParameter),
        ])
    }, 200, [stateModuleParameter])

    return (
        <Grid container justifyContent='space-between' alignItems='center' columnSpacing={1}>
            <Grid size={0.5}>
                <HelpParameter image={helpImage} />
            </Grid>
            <Grid container size='grow'>
                <Typography variant='normalFormTitle'>{title}</Typography>
            </Grid>
            <Grid size={3.25}>
                <SimpleInput
                    value={stateParameter}
                    onChange={setStateParameter}
                    placeholder={placeholder}
                    disabled={!isGlobal}
                    type={type}
                />
            </Grid>
            {!isGlobal && (
                <Grid size={3.25}>
                    <SimpleInput
                        value={stateModuleParameter}
                        onChange={setStateModuleParameter}
                        placeholder={placeholder}
                        type={type}
                    />
                </Grid>
            )}
            <Grid size={0.5}>
                {iconTooltip}
            </Grid>
        </Grid>
    )
}

ParameterWithSimpleInput.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    isGlobal: PropTypes.bool,
    parameter: PropTypes.string,
    title: PropTypes.string,
    helpImage: PropTypes.node,
    placeholder: PropTypes.string,
    iconTooltip: PropTypes.node,
    type: PropTypes.string,
}

export default ParameterWithSimpleInput
